<template>
    <div class="tjyh" v-loading.fullscreen.lock="loading">
        <div class="radio">
            <el-radio-group v-model="tabPosition"
                            style="margin-bottom: 30px"
                            @change="clear">
                <el-radio-button label="dw">单位人员</el-radio-button>
                <el-radio-button label="ks">科室人员</el-radio-button>
                <el-radio-button label="gly">管理员</el-radio-button>
            </el-radio-group>
        </div>
        <div class="main">
            <div class="main-c">
                <div class="option" v-show="tabPosition == 'dw'">
                    所属单位:
                    <div style="width: 60%; margin-left: 40px">
                        <el-select v-model="divid"
                                   filterable
                                   placeholder="请选择"
                                   style="width: 100%">
                            <el-option v-for="item in dwOptions"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="option" v-show="tabPosition == 'ks'">
                    所属科室:
                    <div style="width: 60%; margin-left: 40px">
                        <el-select v-model="divid"
                                   filterable
                                   placeholder="请选择"
                                   style="width: 100%">
                            <el-option v-for="item in ksOptions"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="option">
                    用 户 名:
                    <div style="width: 60%; margin-left: 40px">
                        <el-input v-model="id" placeholder="用户登录名"></el-input>
                    </div>
                </div>
                <div class="option">
                    登录密码:
                    <div style="width: 60%; margin-left: 40px">
                        <el-input v-model="password" placeholder="用户登录密码"></el-input>
                    </div>
                </div>
                <div class="button">
                    <el-button @click="addUser">添加用户</el-button>
                    <el-button @click="goback">取消</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { addDivUser,addZoneUser } from "@/api/user.js";
    import { getDivs } from '@/api/div.js';
    export default {
        name: "tjyh",
        data() {
            return {
                tabPosition: "dw",
                divid: "",
                id: "",
                password: "",
                loading: false,
                dwOptions: [],
                ksOptions: [],
            };
        },
        created() {
            this.init();
        },
        methods: {
            clear(val) {
                this.divid = "";
                this.id = "";
                this.password = "";
            },
            async addUser() {
                const self = this;
                if (this.divid == "" && self.tabPosition == "dw") {
                    self.$message.error("所属单位不得为空!");
                } else if (this.divid == "" && self.tabPosition == "ks") {
                    self.$message.error("所属科室不得为空!");
                } else if (this.id == "") {
                    this.$message.error("用户名不得为空!");
                } else if (this.password == "") {
                    this.$message.error("密码不得为空!");
                } else {
                    this.loading = true;
                    if (self.tabPosition == "gly") {
                        addZoneUser({
                                id: this.id,
                                password: this.password,
                            })
                            .then((res) => {
                                if (res.status == 0) {
                                    this.divid = "";
                                    this.password = "";
                                    this.id = "";
                                    this.$message.success("添加成功!");
                                }
                            })
                            .catch((err) => { });
                    } else {
                        try {
                            let res = await addDivUser({
                                divid: this.divid,
                                password: this.password,
                                id: this.id,
                            });
                            if (res.status == 0) {
                                this.divid = "";
                                this.password = "";
                                this.id = "";
                                this.$message.success("添加成功!");
                            }
                        } catch (e) { }
                    }
                    this.loading = false;
                }
            },
            init() {
                this.loading = true
                getDivs().then(res => {
                    this.dwOptions = res.divs.filter((e) => e.type !== 1);
                    this.ksOptions = res.divs.filter((e) => e.type == 1);
                    this.loading = false
                }).catch(err=>{
                    this.loading = false
                })
            },
            goback() {
                this.$router.push({ name: "用户列表" });
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
        },
    };
</script>

<style scoped>
    .tjyh {
        height: 500px;
        width: 80%;
        margin: 0 auto;
        margin-top: 100px;
    }

        .tjyh .radio {
            display: flex;
            justify-content: center;
        }

    .main {
        display: flex;
        justify-content: center;
        align-items: center;
    }

        .main .main-c {
            height: 400px;
            width: 50%;
        }

            .main .main-c .option {
                height: 80px;
                margin: 10px 0;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 55px !important;
                font-size: 20px !important;
                font-weight: 500 !important;
                font-family: fangsong !important;
            }

    .button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>